var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6776 9.08912H22.5665C22.2917 9.0883 22.0284 8.97912 21.8341 8.78542C21.6398 8.59172 21.5302 8.32924 21.5294 8.05531V4.95386L25.6776 9.08912Z",
    fill: "#AAC4DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6776 9.08912V27.6978C25.6768 27.9718 25.5672 28.2342 25.3729 28.4279C25.1786 28.6216 24.9153 28.7308 24.6406 28.7316H8.04796C7.77318 28.7308 7.50988 28.6216 7.31557 28.4279C7.12127 28.2342 7.01175 27.9718 7.01093 27.6978V5.98767C7.01175 5.71374 7.12127 5.45126 7.31557 5.25756C7.50988 5.06386 7.77318 4.95468 8.04796 4.95386H21.5294V8.05531C21.5303 8.32924 21.6398 8.59172 21.8341 8.78542C22.0284 8.97912 22.2917 9.08831 22.5665 9.08912H25.6776Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49982 8.15869H14.4776",
    stroke: "#4C5B66",
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6776 27.6978C25.6776 27.972 25.5683 28.235 25.3738 28.4288C25.1794 28.6227 24.9156 28.7316 24.6406 28.7316H8.04796C7.77292 28.7316 7.50915 28.6227 7.31467 28.4288C7.12018 28.235 7.01093 27.972 7.01093 27.6978V5.98767C7.01093 5.71349 7.12018 5.45053 7.31467 5.25666C7.50915 5.06278 7.77292 4.95386 8.04796 4.95386H21.5294L25.6776 9.08912V27.6978Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6776 27.6978C25.6776 27.972 25.5683 28.235 25.3738 28.4288C25.1794 28.6227 24.9156 28.7316 24.6406 28.7316H8.04796C7.77292 28.7316 7.50915 28.6227 7.31467 28.4288C7.12018 28.235 7.01093 27.972 7.01093 27.6978V5.98767C7.01093 5.71349 7.12018 5.45053 7.31467 5.25666C7.50915 5.06278 7.77292 4.95386 8.04796 4.95386H21.5294L25.6776 9.08912V27.6978Z",
    fill: "url(#paint0_linear_570_169479)",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6776 27.6978C25.6776 27.972 25.5683 28.235 25.3738 28.4288C25.1794 28.6227 24.9156 28.7316 24.6406 28.7316H8.04796C7.77292 28.7316 7.50915 28.6227 7.31467 28.4288C7.12018 28.235 7.01093 27.972 7.01093 27.6978V5.98767C7.01093 5.71349 7.12018 5.45053 7.31467 5.25666C7.50915 5.06278 7.77292 4.95386 8.04796 4.95386H21.5294L25.6776 9.08912V27.6978Z",
    stroke: "#4C5B66",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49982 9.39926H17.2776",
    stroke: "#4C5B66",
    strokeWidth: 1.86087,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2702 15.809H22.048",
    stroke: "#59A5EE",
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2702 14.2582H22.5665",
    stroke: "#59A5EE",
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2702 12.7075H21.5295",
    stroke: "#59A5EE",
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60352 14.2582H13.2331",
    stroke: "#59A5EE",
    strokeWidth: 5.58261,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60352 19.4273H22.048",
    stroke: "#4C5B66",
    strokeOpacity: 0.4,
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60352 20.9781H22.048",
    stroke: "#4C5B66",
    strokeOpacity: 0.4,
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60352 22.5288H22.5665",
    stroke: "#4C5B66",
    strokeOpacity: 0.4,
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60352 24.0795H21.0109",
    stroke: "#4C5B66",
    strokeOpacity: 0.4,
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60352 25.6302H22.048",
    stroke: "#4C5B66",
    strokeOpacity: 0.4,
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0554 9.08912H22.5665C22.2914 9.08912 22.0276 8.9802 21.8332 8.78632C21.6387 8.59245 21.5294 8.32949 21.5294 8.05531V4.95386",
    stroke: "#4C5B66",
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_570_169479",
    x1: 17.9116,
    y1: 14.3983,
    x2: 15.9154,
    y2: 16.2756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562501,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656252
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.ba6c31f0a0e8673ccb97b7cedca36545.svg";
export { ForwardRef as ReactComponent };